import s from "./Footer.module.scss";

const Footer = () => {
  return (
    <footer className={s.footer}>
      <p>
        Music by Soundwalk Collective
        <br />
        Voices: Mulay Winter, Youka Snell
        <br />
        Photography of the savoir-faire by Till Janz
        <br />
        Photography of the scenography by Adrien Dirand
        <br />
        Scenography animation : @gourauphong / Gourau Phong
      </p>
    </footer>
  );
};

export default Footer;
